import { createContext } from 'react'

export type AuthUser = { id: string; name: string; email: string }

export type AuthContextValue = {
  user: AuthUser | null
  isAuthenticated: boolean
  signIn: (email: string) => void
  signOut: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
